import { IAppState } from '../../../AppModulesWrapper';

import { EElementsVisibilitySummaryView } from '../../types/reducers/elementsVisibility';

export const selectSummaryViewMode = (state: IAppState): EElementsVisibilitySummaryView => {
  return state.servicePickerWidget.elementsVisibility.summary.view;
};
